/**
 * Node Modules
 */
import React from 'react'

/**
 * Application Modules
 */
import './style.css'
import '../../../components/styles/buttons.css'
import Section from '../../../components/section'
import {HeroPrimary, CopySecondaryDiv} from '../../../components/typography'
import Spacer from '../../../components/spacer'

/**
 * Component
 */
export default function Hero({ hed, dek }) {

  return (
    <Section className="guidelines-hero">
      <div className="guidelines-hero__grid grid">
        <div className="column-start-1 column-end-6 column-start-2--t column-end-11--t  column-start-3--d column-end-10--d">
          <Spacer size={[50, 100]} />
          <HeroPrimary className="guidelines-hero__hed">
            {hed}
          </HeroPrimary>
          <Spacer size={[30, 30]} />
          <CopySecondaryDiv className="guidelines-hero__dek">
            <p>
              Kinzoo is a private messaging app designed from the ground up for kids and their parents.  It's a place where people of all ages share and connect with loved ones, so it's important that we make sure everyone feels welcome on Kinzoo. 
            </p>
            <Spacer size={[14, 24]} />
            <p>
              These community guidelines are here to ensure that you, your family and your friends all feel safe and excited to share your most important moments on Kinzoo. Thank you for helping us create a positive, safe space for families!
            </p>
          </CopySecondaryDiv>
          <Spacer size={[110, 180]} />
        </div>
      </div>
    </Section>
  )
}
